export enum RMS_REQUEST_TYPES {
  CONCRETE = 'C',
  CONCRETE_PUMP = 'CP',
}

export enum RMS_STATUS_TYPES {
  CANCEL = 'CNCO',
  ON_HOLD = 'HOLD',
  IN_PROGRESS = 'INPC',
}

export enum ReasonsForRMS {
  HOLD_REASON = '950',
  IN_PROGRESS_REASON = '169',
}
